import api from './api';
import { CreateEventRequest, UpdateEventRequest, UserEvent } from '../types/types';
import { logger } from './logger';

const getApiPrefix = () => {
  const baseUrl = process.env.REACT_APP_API_URL || '';
  return baseUrl.endsWith('/api') ? '' : '/api';
};

export const createUserEvent = async (payload: CreateEventRequest): Promise<UserEvent> => {
  try {
    const response = await api.post(`${getApiPrefix()}/my-events/`, payload);
    return response.data;
  } catch (error) {
    logger.error('Error creating user event:', error);
    throw error;
  }
};

export const updateUserEvent = async (
  id: number,
  payload: UpdateEventRequest
): Promise<UserEvent> => {
  try {
    const response = await api.patch(`${getApiPrefix()}/my-events/${id}/`, payload);
    return response.data;
  } catch (error) {
    logger.error('Error updating user event:', error);
    throw error;
  }
};

export const deleteUserEvent = async (id: number): Promise<void> => {
  try {
    await api.delete(`${getApiPrefix()}/my-events/${id}/`);
  } catch (error) {
    logger.error('Error deleting user event:', error);
    throw error;
  }
};

export const getUserEvents = async (): Promise<UserEvent[]> => {
  try {
    const response = await api.get(`${getApiPrefix()}/my-events/`);
    return response.data;
  } catch (error) {
    logger.error('Error fetching user events:', error);
    throw error;
  }
};

export const submitEventForReview = async (id: number): Promise<UserEvent> => {
  try {
    const response = await api.post(`${getApiPrefix()}/my-events/${id}/submit_for_review/`);
    return response.data;
  } catch (error) {
    logger.error('Error submitting event for review:', error);
    throw error;
  }
};
